// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import './styles/LoginForm.css';
// import logo from './assets/carrenahealth-logo.png';

// const LoginForm = () => {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [message, setMessage] = useState('');
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setMessage('');

//     try {
//       console.log('Attempting login...');
//       const response = await axios.post(
//         'https://api.carrenahealth.com/api/auth/login',
//         { email, password },
//         {
//           headers: { 
//             'Content-Type': 'application/json',
//             'Accept': 'application/json'
//           },
//           withCredentials: true
//         }
//       );

//       console.log('Login response:', response.data);

//       if (response.data?.user?.role) {
//         const role = response.data.user.role.toLowerCase();
//         console.log('Navigating to:', `/${role}`);
//         navigate(`/${role}`);
//       } else {
//         setMessage('Invalid response format');
//         console.error('Invalid response format:', response.data);
//       }
//     } catch (err) {
//       console.error('Login error:', err.response || err);
//       setMessage(err.response?.data?.message || 'Login failed');
//     } finally {
//       setLoading(false);
//     }
//   };

// frontend/src/LoginForm.js - FULL DROP-IN REPLACEMENT

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './styles/LoginForm.css';
import logo from './assets/carrenahealth-logo.png';

const LoginForm = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');

        try {
            console.log('Attempting login...');
            const response = await axios.post(
                'https://api.carrenahealth.com/api/auth/login',
                { email, password },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    withCredentials: true
                }
            );

            console.log('Login response:', response); // Log the FULL response, not just response.data

            if (response.status === 200 && response.data?.user?.role) { // Check status code explicitly
                const role = response.data.user.role.toLowerCase();
                console.log('Navigating to:', `/${role}`);

                // Store user data in local storage or session storage if needed
                localStorage.setItem('user', JSON.stringify(response.data.user));

                navigate(`/${role}`);
            } else {
                setMessage('Invalid response from server');
                console.error('Invalid response format:', response); // Log the full response on error
            }
        } catch (err) {
            console.error('Login error:', err.response || err);
            setMessage(err.response?.data?.message || 'Login failed');
        } finally {
            setLoading(false);
        }
    };

  return (
    <div className="login-page">
      <div className="login-container">
        <img src={logo} alt="Carrena Health" className="login-logo" />
        <p className="tagline">Compassionate care, continuously connected.</p>

        <form className="login-form" onSubmit={handleLogin}>
          <div className="input-group">
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="username"
              disabled={loading}
            />
          </div>

          <div className="input-group">
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              disabled={loading}
            />
          </div>

          <button 
            type="submit" 
            className="login-button"
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>

          {message && (
            <div className="message error">
              {message}
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default LoginForm;